export const ActionCodes = {
    S_001: 'USER REGISTERED SUCCESSFULLY',
    S_001_0: 'USER REGISTERED FAILED',

    S_002: 'USER LOGIN SUCCESSFUL',
    S_002_0: 'USER LOGIN FAILED',
    S_003_0: "CHECK CREDENTIALS"

}